import { render, staticRenderFns } from "./ChatsNavigator.vue?vue&type=template&id=43960a04&"
import script from "./ChatsNavigator.vue?vue&type=script&lang=js&"
export * from "./ChatsNavigator.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/messages/chats-navigator.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports